"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createFetch = void 0;
var http_error_1 = require("./errors/http-error");
var network_1 = require("./errors/network");
var timeout_1 = require("./errors/timeout");
/**
 * Create a fetch function with a baseUrl and auth token curried in.
 */
function createFetch(options) {
    var _this = this;
    var baseUrl = options.baseUrl, getToken = options.getToken, _a = options.throwOnError, throwOnError = _a === void 0 ? false : _a, _b = options.globalFetch, globalFetch = _b === void 0 ? fetch : _b, _c = options.timeoutInMilliseconds, timeoutInMilliseconds = _c === void 0 ? 10000 : _c;
    return function (input, init) { return __awaiter(_this, void 0, void 0, function () {
        var token, options, request, response, error_1, responseBody;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!getToken) return [3 /*break*/, 2];
                    return [4 /*yield*/, getToken()];
                case 1:
                    token = _a.sent();
                    _a.label = 2;
                case 2:
                    options = __assign(__assign({}, init), { headers: __assign(__assign({}, ((init === null || init === void 0 ? void 0 : init.headers) || {})), { Authorization: token ? "Bearer ".concat(token) : '' }) });
                    request = new Request("".concat(baseUrl || '').concat(input), options);
                    _a.label = 3;
                case 3:
                    _a.trys.push([3, 5, , 6]);
                    return [4 /*yield*/, Promise.race([
                            globalFetch(request),
                            new Promise(function (_, reject) {
                                setTimeout(function () { return reject(new timeout_1.TimeoutError(request)); }, timeoutInMilliseconds);
                            }),
                        ])];
                case 4:
                    response = _a.sent();
                    return [3 /*break*/, 6];
                case 5:
                    error_1 = _a.sent();
                    // The only way to detech network errors with fetch is to look for TypeError
                    // being thrown. This is part of the Fetch spec. We want to give it a more descriptive
                    // error so that we can handle it more gracefully.
                    // Normally retries would be implemented here but we have that handled for us by TRPC.
                    if (error_1 instanceof Error && error_1.name === 'TypeError') {
                        throw new network_1.NetworkError(request);
                    }
                    // Some other unhandled exception, timeout error, or programmer error.
                    throw error_1;
                case 6:
                    if (!(!response.ok && response.status >= 400 && throwOnError)) return [3 /*break*/, 8];
                    return [4 /*yield*/, response.json()];
                case 7:
                    responseBody = _a.sent();
                    throw new http_error_1.HTTPError(response, request, responseBody, options);
                case 8: return [2 /*return*/, response];
            }
        });
    }); };
}
exports.createFetch = createFetch;
